import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { getColorObjectStyleByRecord } from 'PDF/helpers/documentStyle';

import { IGoalsTableHeader } from './types';

interface ITableRowProps {
  info: string[];
  header: IGoalsTableHeader[];
  isGermanLang?: boolean;
}
const colorIndexes = {
  green: 2,
  blue: 2,
  red: 2,
  blueGreen: 2,
  blueRed: 2,
  blueYellow: 35,
};

export const TableRow = ({ info, header, isGermanLang: _ = false }: ITableRowProps) => {
  return (
    <View id="row" style={[styles.rowBackgroundWrapper, getColorObjectStyleByRecord(colorIndexes, 'backgroundColor')]}>
      <View style={styles.rowWrapper} wrap={false}>
        {info?.map((label, index) => {
          const { width, isBold, isCenter } = header[index];

          return (
            <View
              key={index}
              style={[
                styles.ceilWrapper,
                {
                  width: width,
                  textAlign: isCenter ? 'center' : undefined,
                  paddingLeft: index === 0 ? 12 : 0,
                  paddingRight: 12,
                  flexShrink: index === 0 ? 1 : undefined,
                },
              ]}
            >
              <Text style={[styles.goalText, { fontWeight: isBold ? 600 : undefined }]}>{label}</Text>
            </View>
          );
        })}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  rowBackgroundWrapper: {
    padding: '0 19px 4px 19px',
  },
  rowWrapper: {
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '7px 0',
  },
  ceilWrapper: {
    fontSize: 9,
    fontFamily: 'Noto',
    width: 149,
  },
  goalText: {
    fontWeight: 300,
    color: '#000',
    flexShrink: 1,
  },
});
